var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDdproject(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5001",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5005"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath5015"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path5013"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath5029"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path5027"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath5065"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path5063"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5007",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5011",
    clipPath: "url(#clipPath5015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 504.287,7.356 H 7.291 V 69.64 h 496.996 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 364.507,7.356 H 147.071 v 31.062 h 217.436 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5019"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 333.444,38.418 H 178.133 V 69.48 h 155.311 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5021"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5025",
    clipPath: "url(#clipPath5029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5031",
    transform: "translate(434.6289,459.9541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 70.08,-17.55 v -62.23 h -497 v 62.23 l 248.5,62.239 146.72,-36.75",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5033"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5035",
    transform: "translate(84.9492,181.5937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -111.96 H -46.601 V 198.67 H 0 V 32.681",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5037"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5039",
    transform: "translate(38.3535,69.6377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 46.593,62.125 0,124.12 46.593,186.245 0,248.369 46.593,310.623",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5043",
    transform: "translate(426.6289,175.9941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -106.36 H 46.601 V 204.27 L 0,204.27 V 32.689",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5045"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5047",
    transform: "translate(473.2246,69.6377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -46.594,62.125 0,124.121 -46.594,186.245 0,248.37 -46.594,310.623",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5049"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5051",
    transform: "translate(255.7891,193.7578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -124.12",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5053"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5055",
    transform: "translate(270.7891,186.4492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -46.063,22.969",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5057"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5061",
    clipPath: "url(#clipPath5065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5067",
    transform: "translate(279.0859,318.1357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -46.594 v 7.766 c 0,12.866 10.431,23.296 23.297,23.296 C -10.431,31.062 0,20.632 0,7.766 Z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5069"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5071",
    transform: "translate(177.4668,339.1582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -32.946,-32.946 -5.492,5.491 c -9.097,9.098 -9.097,23.849 0,32.946 9.099,9.098 23.849,9.098 32.948,0 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5073"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5075",
    transform: "translate(131.54,380.2607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 7.489,-35.611",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5077"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5079",
    transform: "translate(334.1113,339.1582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 32.946,-32.946 5.492,5.491 c 9.097,9.098 9.097,23.849 0,32.946 -9.099,9.098 -23.849,9.098 -32.948,0 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5081"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5083",
    transform: "translate(380.0381,380.2607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -7.489,-35.611",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5085"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5087",
    transform: "translate(256.207,473.708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -124.249,-31.062 V -61.965 H 124.249 V -31.3 Z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5089"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5091",
    transform: "translate(255.7891,380.2607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -31.062",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path5093"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdproject);
export default __webpack_public_path__ + "static/media/ddproject.18c93536512ff1def9d970434dc3a5cf.svg";
export { ForwardRef as ReactComponent };